import styled from 'styled-components';
import FlightHeadSvg from '../../assets/header/flight.svg';

const FlightHeadIcon = styled(FlightHeadSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '3.3rem'};
height: ${props => props.height || '3.3rem'};
margin: ${props => props.margin};
fill: ${props => props.fill};
`;

export default FlightHeadIcon;
